module.exports = __webpack_public_path__ + "static/img/case1.fa6b4ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/ldt/case1.png
// module id = CERK
// module chunks = 0